// Isi popup dot trail. Fungsi murni: wave & label RPM disuntik dari luar.
import { convertDecimalToDMS } from '../../views/map/utils/coordinates.js';
import { formatNum } from '../number.js';
import { waveRows } from './voyageMapExtras.js';
import { kmhToKnot, metersToNm } from '../units.js';

// Pembungkus null-safe buat kmhToKnot: input kosong balikin null, bukan NaN.
export function kmhToKnots(speedKmh) {
  if (speedKmh === null || speedKmh === undefined || Number.isNaN(Number(speedKmh))) {
    return null;
  }
  return kmhToKnot(speedKmh);
}

export function buildDotTrailGroups(data, detail, { wave = false, rpmLabel = (type) => type } = {}) {
  // key undefined di detail jangan nimpa isi data (mis. locationText hasil geocode).
  const src = { ...data };
  Object.entries(detail || {}).forEach(([k, v]) => { if (v !== undefined) src[k] = v; });
  const num = (v) => Number.isFinite(Number(v));
  const lat = src?.latLong?.[0];
  const lng = src?.latLong?.[1];
  // speedKnots dari rollup udah knot — jangan diconvert lagi. Field speed/
  // avgSpeed (dari processSummarySeriesData) masih km/h, itu yang diconvert.
  const speedKn = Number.isFinite(Number(src?.speedKnots))
    ? Number(src.speedKnots)
    : kmhToKnots(src?.speed ?? src?.gpsData?.speed ?? src?.avgSpeed ?? null);

  const rows = [
    {
      label: 'Coordinates',
      value: num(lat) && num(lng)
        ? `${convertDecimalToDMS(lat, true)}, ${convertDecimalToDMS(lng, false)}`
        : '-',
      full: true,
    },
    { label: 'Location', value: src.locationText || '-', full: true },
    { label: 'Speed', value: speedKn !== null ? `${formatNum(speedKn, 2)} kn` : '-' },
    { label: 'Heading', value: num(src?.heading) ? `${Math.round(src.heading)}°` : '-' },
    { label: 'Total Cruise', value: num(src?.totalCruise) ? `${formatNum(metersToNm(src.totalCruise), 2)} NM` : '-' },
    { label: 'Current AE', value: src?.currentAe ? `AE ${src.currentAe}` : '-' },
  ];
  const groups = [{ label: 'Position', rows }];

  const rpmOf = (type) => {
    const key = `${type.toLowerCase()}Rpm`;
    return (src || {})[key];
  };
  const rpmTypes = ['PORT', 'STARBOARD', 'CENTER'].filter((type) => num(rpmOf(type)));
  if (rpmTypes.length) {
    groups.push({
      label: 'RPM',
      rows: rpmTypes.map((type) => ({
        label: `${rpmLabel(type, rpmTypes)} RPM`,
        value: formatNum(Number(rpmOf(type)), 2),
      })),
    });
  }
  if (wave) {
    const waves = waveRows(src.gpsData);
    if (waves.length) groups.push({ label: 'Wave', rows: waves });
  }
  return groups;
}
